import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';

import { asRecord } from '../../activities/types.js';
import { locatorOf, toPointer } from '../../core/issues.js';

const isScoredSwipe = (activity: unknown): boolean => {
  const { type, setup } = asRecord(activity);
  return type === 'swipe_select' && asRecord(setup).requireCorrectAnswer === false;
};

/**
 * A swipe deck is never scored: it always finishes `complete`, so `requireCorrectAnswer: false`
 * on one asks for something the player does not do.
 */
export const swipeSelectFinishesComplete: Rule<unknown> = {
  code: 'story.swipe',
  check(input): ValidationIssue[] {
    const nodes = (input as { nodes?: unknown }).nodes;
    if (!Array.isArray(nodes)) {
      return [];
    }
    return nodes.flatMap((node, nodeIdx): ValidationIssue[] => {
      const { id, activity } = asRecord(node);
      if (!isScoredSwipe(activity)) {
        return [];
      }
      const path: (string | number)[] = ['nodes', nodeIdx, 'activity', 'setup', 'requireCorrectAnswer'];
      return [{
        code: 'story.swipe.scored',
        severity: 'error',
        message: `Node ${String(id)}: a swipe deck is never scored and always finishes 'complete'. Remove requireCorrectAnswer: false and route the deck on 'complete'.`,
        path,
        pointer: toPointer(path),
        locator: locatorOf({ nodeId: id }),
        currentValue: false,
        constraint: { kind: 'shape', detail: 'swipe_select finishes complete' },
        fix: { kind: 'remove', rationale: `Removed requireCorrectAnswer from the swipe deck in ${String(id)}` },
      }];
    });
  },
};
